import { render, staticRenderFns } from "./InvitedLecturerView.vue?vue&type=template&id=93fcd668&scoped=true"
import script from "./InvitedLecturerView.vue?vue&type=script&lang=js"
export * from "./InvitedLecturerView.vue?vue&type=script&lang=js"
import style0 from "./InvitedLecturerView.vue?vue&type=style&index=0&id=93fcd668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fcd668",
  null
  
)

export default component.exports